import { useMutation } from '@apollo/client';

import { UpdateJobPreferencesDocument } from '@xing-com/crate-jobs-graphql';

import type {
  UpdateJobPreferencesMutationParams,
  UseUpdateJobPreferences,
} from './types';

const DEFAULT_PARAMS = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onError: (): void => {},
};

export const useUpdateJobPreferences = (
  params?: UpdateJobPreferencesMutationParams
): UseUpdateJobPreferences => {
  const { onError } = {
    ...DEFAULT_PARAMS,
    ...(params ?? {}),
  };

  const [updateJobPreferencesX1] = useMutation(UpdateJobPreferencesDocument);

  return ({
    onCompleted,
    showError = true,
    careerLevelPreferenceInput,
    disciplinesPreferenceInput,
    industriesPreferenceInput,
    jobTitlesTargetPositionsInput,
    locationsPreferenceInput,
    salaryExpectationsPreferenceInput,
    workingHoursPreference,
    workplacePreferenceInput,
  }) => {
    updateJobPreferencesX1({
      variables: {
        careerLevelPreferenceInput,
        disciplinesPreferenceInput,
        industriesPreferenceInput,
        jobTitlesTargetPositionsInput,
        locationsPreferenceInput,
        salaryExpectationsPreferenceInput,
        workingHoursPreference,
        workplacePreferenceInput,
      },
      onCompleted: (response) => {
        const isErrorResponse =
          response.careerLevelPreference?.__typename ===
            'UpdateCareerLevelPreferenceError' ||
          response.disciplinesPreference?.__typename ===
            'UpdateDisciplinesPreferenceError' ||
          response.industriesPreference?.__typename ===
            'UpdateIndustriesPreferenceError' ||
          response.jobTitlesTargetPositions?.__typename ===
            'UpdateJobTitlesTargetPositionsPreferenceError' ||
          response.locationsPreference?.__typename ===
            'UpdateLocationsPreferenceError' ||
          response.salaryExpectationsPreference?.__typename ===
            'UpdateSalaryExpectationsPreferenceError' ||
          response.workingHoursPreference?.__typename ===
            'UpdateWorkingHoursPreferenceError' ||
          response.workplacePreference?.__typename ===
            'UpdateWorkplacePreferenceError';

        if (showError && isErrorResponse) {
          onError();
        }

        onCompleted?.(response);
      },
      onError,
    });
  };
};
